import { breakpoints } from 'styles/theme/breakpoints';

export const timelineSwiperBreakpoints = {
  [breakpoints.small]: {
    slidesPerGroup: 3,
  },
  [breakpoints.mediumSmall]: {
    slidesPerGroup: 10,
  },
  840: {
    slidesPerGroup: 11,
  },
  890: {
    slidesPerGroup: 12,
  },
  945: {
    slidesPerGroup: 13,
  },
  1000: {
    slidesPerGroup: 14,
  },
  [breakpoints.medium]: {
    slidesPerGroup: 15,
  },
};
